import { Paper } from '@mui/material';
import React, { FC, ReactNode } from 'react';

type ClickablePaperProps = {
	onClick: () => void;
	disableClick?: boolean;
	sx: any;
	children: ReactNode;
};

export const ClickablePaper: FC<ClickablePaperProps> = ({ onClick, disableClick = false, sx, children }) => {
	const PaperComponent = <Paper sx={sx}>{children}</Paper>;

	if (disableClick) return PaperComponent;

	return (
		<button
			onClick={onClick}
			type='button'
			style={{
				border: 'none',
				width: '100%',
				cursor: 'pointer',
			}}
		>
			{PaperComponent}
		</button>
	);
};
